import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "dropdownButton", "selectedCount"];

  connect() {
    this.updateBulkActionsState();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.updateBulkActionsState();
  }

  toggleCheckbox() {
    const allChecked = this.checkboxTargets.every(
      (checkbox) => checkbox.checked
    );
    const someChecked = this.checkboxTargets.some(
      (checkbox) => checkbox.checked
    );

    this.selectAllTarget.checked = allChecked;
    this.selectAllTarget.indeterminate = someChecked && !allChecked;

    this.updateBulkActionsState();
  }

  updateBulkActionsState() {
    const selectedCount = this.getSelectedIds().length;

    // Update selected count text
    if (this.hasSelectedCountTarget) {
      if (selectedCount > 0) {
        this.selectedCountTarget.textContent = `${selectedCount} selected`;
      } else {
        this.selectedCountTarget.textContent = "Select reservations";
      }
    }

    // Enable/disable dropdown button based on selection
    if (this.hasDropdownButtonTarget) {
      if (selectedCount > 0) {
        this.dropdownButtonTarget.classList.remove("disabled");
        this.dropdownButtonTarget.disabled = false;
      } else {
        this.dropdownButtonTarget.classList.add("disabled");
        this.dropdownButtonTarget.disabled = false; // Keep enabled for visual feedback
      }
    }

    // Update bulk action links with selected IDs
    if (selectedCount > 0) {
      this.updateBulkActionLinks();
    }
  }

  updateBulkActionLinks() {
    const ids = this.getSelectedIds();
    const idsParam = ids.join(",");

    // Update all bulk action links with selected IDs
    this.element.querySelectorAll("[data-bulk-action]").forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set("ids", idsParam);
      link.href = url.toString();
    });
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  }
}
